import Node from 'ln/node/Node';
import Template from "ln/template/TemplateManager";
import BaseCourseListFilterView from './BaseCourseListFilterView';
import Backend from 'ln/backend/Backend';
import Request from 'ln/request/Request';
import CourseModel from '../../course/models/CourseModel';
import UserCourseModel from '../../course/models/UserCourseModel';
import setup from 'ln/setup/setup';

interface IComparisonAttributes{
	tagFilterAttributes: Array<string>;
	searchFilterAttributes: Array<string>;
}


class SharedCourseListFilterView extends BaseCourseListFilterView {

	public constructor( courses:Array<CourseModel|UserCourseModel>, comparisonAttributes:IComparisonAttributes ) {
		super( courses, comparisonAttributes );

	}

	/**
	 * @overwrite
	 */
	protected renderCourses() {

		super.renderCourses();

		this.courseListRenderer.ioc.add( 'App\\UserCourse', ( item:UserCourseModel ) => {
			var node = Node.fromHTML( Template.render( 'krw.courselistcourse-shared', item ) );

			node.one( '.duplicate-course' ).click.add( () => {
				this.duplicateSharedCourse( item );
			});

			node.one( '.remove-course' ).click.add( () => {
				this.showDialog( item, this.removeSharedCourse.bind( this ), 'library.dialog.confirm-remove' );
			});

			return { node : node };
		});

		this.courseListRenderer.source = this.courseList;
	}

	private duplicateSharedCourse( course:UserCourseModel ){
		/* var apiPath = ( course.backend as Backend ).apiPath;
		Request.get( apiPath + '/duplicate-shared/' + course.id ).load().then( ( result:string ) => {
			window.location.reload( true );
		}); */

		setup.route( 'api.duplicate.shared', { id:course.id } ).load().then( ( result ) => {
			window.location.reload( true );
		});
	}
	
	private removeSharedCourse( course:UserCourseModel ){
		/* var apiPath = ( course.backend as Backend ).apiPath;
		Request.get( apiPath + '/remove-shared/' + course.id ).load().then( () => {
			this.courseList.originals.remove( course );
		}); */

		setup.route( 'api.remove.shared', { id:course.id } ).load().then( ( result ) => {
			this.courseList.originals.remove( course );
		});

	}
}

export default SharedCourseListFilterView;